import React from 'react';
import resume from '../assets/myresume.pdf';

export default function About() {
  return (
    <div className="container" id="skills">
      <h2>Skills</h2>

      <h3>Front-End Proficiencies</h3>
      <p>HTML, CSS, Bootstrap, JavaScript, React, jQuery, Swift, Storyboard, Auto Layout, Responsive Design</p>

      <h3>Back-End Proficiencies</h3>
      <p>Node.js, Express.js, MySQL, MongoDB, RESTful APIs, JSON, Authentication, Command Line</p>

      <h3>Programming Languages</h3>
      <p>Swift, Java, JavaScript, Python</p>

      <h3>Developer Tools & Frameworks</h3>
      <p>Xcode, Git / GitHub, VS Code, Postman, npm, Homebrew</p>

      <h3>Core Concepts</h3>
      <p>Object-Oriented Programming (OOP), Data Structures & Algorithms, Debugging, Version Control, API Integration, Problem Solving</p>

      <h3>Currently Expanding Skills</h3>
      <p>Advancing full-stack development with Node.js, React, and Python integration.</p>

      <hr />

      <div>
        <h2>Resume</h2>
        <div className="resume-container">
          <a 
            className="resume" 
            href={resume} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            View Resume
          </a>
        </div>
      </div>
    </div>
  );
}
